import { render, staticRenderFns } from "./xlsyx.vue?vue&type=template&id=956b84d2&scoped=true"
import script from "./xlsyx.vue?vue&type=script&lang=js"
export * from "./xlsyx.vue?vue&type=script&lang=js"
import style0 from "./xlsyx.vue?vue&type=style&index=0&id=956b84d2&prod&scoped=true&lang=css"
import style1 from "./xlsyx.vue?vue&type=style&index=1&id=956b84d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956b84d2",
  null
  
)

export default component.exports